module.exports = __webpack_public_path__ + "images/mazda_small3b468cbcea5727d9040880f8a10c21b6.png";